import { useTranslation } from 'react-i18next';

import { Stack } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

import { CheckIcon } from '../selectableCardGroup/CheckIcon';

import { Discount, PeriodCardContainer } from './styles';

type PeriodCardProps = {
  label: number;
  discountText: number;
  selected?: boolean;
};

export const PeriodCard = ({
  label: count,
  discountText,
  selected,
}: PeriodCardProps) => {
  const { t } = useTranslation();

  const formattedDiscount =
    count !== 1 ? `${t('billing:discount')} ${discountText}%` : undefined;

  return (
    <PeriodCardContainer>
      <Stack
        direction="row"
        justifyContent="space-evenly"
        alignItems="center"
        gap={2}
      >
        <CustomTypography variant="h4">
          {count} {t('billing:month', { count })}
        </CustomTypography>
        {formattedDiscount && (
          <Discount variant="body2" selected={selected}>
            {formattedDiscount}
          </Discount>
        )}
      </Stack>
      <CheckIcon selected={selected} />
    </PeriodCardContainer>
  );
};
